module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-happy.e78f9ab2.png";